<template>
  <button
    @click="$emit('click')"
    :style="badgeStyle"
    :class="['plan-badge', { 'plan-badge-selected': selected }]"
    class="plan-badge-button">
    <strong>{{ plan }}: {{ count }}</strong>
  </button>
</template>

<script>
import { getPlanBadgeStyle } from '@/utils/plan-badge'

export default {
  name: 'DistributionButton',
  props: {
    // O rótulo exibido no botão.
    plan: {
      type: String,
      required: true
    },
    // Código do plano no billing — quem define a cor.
    code: {
      type: String,
      default: null
    },
    count: {
      type: Number,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    badgeStyle () {
      return getPlanBadgeStyle(this.code || this.plan)
    }
  }
}
</script>

<style scoped>
.plan-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.125rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid;
}

.plan-badge-button {
  cursor: pointer;
  transition: opacity 0.2s;
}

.plan-badge-button:hover {
  opacity: 0.85;
}

.plan-badge-selected {
  opacity: 1;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/Users/DistributionButton.vue